import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule, MatDialogModule, MatListModule, MatProgressBarModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule } from '@angular/common/http';
import { FileuploaddialogComponent } from './fileuploaddialog/fileuploaddialog.component';
import { FileuploadComponent } from './fileupload/fileupload.component';
import { MatIconModule } from '@angular/material/icon';

// TODO refactor this module, in order to use it as a general multiple file upload dialog component

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatListModule,
        FlexLayoutModule,
        HttpClientModule,
        BrowserAnimationsModule,
        MatProgressBarModule,
        MatIconModule],
    declarations: [FileuploaddialogComponent, FileuploadComponent],
    exports: [FileuploadComponent],
    entryComponents: [FileuploaddialogComponent],
    providers: []
})
export class FileuploadModule {}

